module.exports = __webpack_public_path__ + "img/icon_map_1.21f7a666.png";